import React, {useEffect, useState} from 'react'
import { connect } from 'react-redux'
import {bindActionCreators} from "redux";
import {setPaymentMethod, setInvoiceData, setPaymentData} from '../actions/nPaymentActions'
import {validateMinLength, validateNumbers} from "../utils/validators";



const NPayment  = props => {

  const {payment_title, payment_method, payment_variants, invoice_variant, setPaymentMethod, setInvoiceData} = props;

  const not_loaded = (props.cart_items.length === 0 && props.cart_num_items > 0) ? true : false;

  //const [invoice_name, setInvoiceName] = useState(invoce_data.name);
  const [invoice_name_error, setInvoiceNameError] = useState("");
  //const [invoice_inn, setInvoiceInn] = useState(invoce_data.inn);
  const [invoice_inn_error, setInvoiceInnError] = useState("");
  //const [invoice_kpp, setInvoiceKpp] = useState(invoce_data.kpp);
  const [invoice_kpp_error, setInvoiceKppError] = useState("");
  //const [invoice_ogrn, setInvoiceOgrn] = useState(invoce_data.ogrn);
  const [invoice_ogrn_error, setInvoiceOgrnError] = useState("");
  //const [invoice_address, setInvoiceAddress] = useState(invoce_data.address);
  const [invoice_address_error, setInvoiceAddressError] = useState("");

  //const [invoice_phone, setInvoicePhone] = useState(invoce_data.phone);
  const [invoice_phone_error, setInvoicePhoneError] = useState("");
  //const [invoice_real_address, setInvoiceRealAddress] = useState(invoce_data.real_address);
  const [invoice_real_address_error, setInvoiceRealAddressError] = useState("");
  //const [invoice_org_schet, setInvoiceOrgSchet] = useState(invoce_data.org_schet);
  const [invoice_org_schet_error, setInvoiceOrgSchetError] = useState("");

  //const [invoice_bank, setInvoiceBank] = useState(invoce_data.bank);
  const [invoice_bank_error, setInvoiceBankError] = useState("");
  //const [invoice_bik, setInvoiceBik] = useState(invoce_data.bik);
  const [invoice_bik_error, setInvoiceBikError] = useState("");
  //const [invoice_bank_schet, setInvoiceBankSchet] = useState(invoce_data.bank_schet);
  const [invoice_bank_schet_error, setInvoiceBankSchetError] = useState("");

  //const [same_address, setSetSameAddress] = useState(true);

  const get_payment_variants_list = ()=> {
      let values = Object.keys(payment_variants).map(function(key){return payment_variants[key]});

      return values.sort(function(a, b) {return a.id - b.id;});

  }
  const payment_variants_list = get_payment_variants_list();

  const invoice = invoice_variant ? invoice_variant.data : {
          name: "",
          inn: "",
          kpp: "",
          ogrn: "",
          address: "",
          phone: "",
          real_address: "",
          org_schet: "",
          bank: "",
          bik: "",
          bank_schet: "",
          same_address: true,
          };

  const handleSelectMethod = (e, method) => {

      e.preventDefault();

      if(payment_method!==method){
          let new_method = payment_variants[method];
          if (new_method){
              setPaymentMethod(method, new_method["title"]);
          }

      }
  }

  const handleChangeSame = (e) => {

    if (!invoice.same_address){
        setInvoiceData({'real_address': invoice.address, "same_address": true});
    }else{
        setInvoiceData({"same_address": false});
    }

  }

  const handleChangInput = (type, value) =>{

      let field_data = Object();
      field_data[type] = value;
      if ((type==="address")&&(invoice.same_address)){
        field_data["real_address"] = value;
      }
      setInvoiceData(field_data);

    };

  const handleSetValue = (type, e) => {

      switch (type) {
          case "name":
              setInvoiceNameError(validateMinLength(invoice.name, 6));
              break;

          case "inn":
              setInvoiceInnError(validateNumbers(invoice.inn) || validateMinLength(invoice.inn, 6));
              break;

          case "kpp":
              if (invoice.kpp.length > 0){
                  setInvoiceKppError(validateNumbers(invoice.kpp) || validateMinLength(invoice.kpp, 6));
              }else{
                  setInvoiceKppError("");
              }
              break;

          case "ogrn":
              setInvoiceOgrnError(validateNumbers(invoice.ogrn) || validateMinLength(invoice.ogrn, 6));
              break;


          case "address":
              setInvoiceAddressError(validateMinLength(invoice.address, 6));
              break;

          case "real_address":
              setInvoiceRealAddressError(validateMinLength(invoice.real_address, 6));
              break;

          case "phone":
              setInvoicePhoneError(validateMinLength(invoice.phone, 6));
              break;

          case "bank":
              setInvoiceBankError(validateMinLength(invoice.bank, 6));
              break;

          case "bik":
              setInvoiceBikError(validateNumbers(invoice.bik) || validateMinLength(invoice.bik, 8));
              break;

          case "bank_schet":
              setInvoiceBankSchetError(validateNumbers(invoice.bank_schet) || validateMinLength(invoice.bank_schet, 19));
              break;

          case "org_schet":
              setInvoiceOrgSchetError(validateNumbers(invoice.org_schet) || validateMinLength(invoice.org_schet, 19));

              break;

          default:
             return true
      }
  };

  return (
    <>
   <div className="nheader"><h2>Способ оплаты <span className="help-link pull-right">
              <a href="/oplata-i-dostavka/oplata/">Об оплате <i className="material-icons">help_outline</i></a></span></h2>
   </div>
   <div className={`nbody${not_loaded ? ' blur': '' }`}>
      <div className="ncart-payment">
          { payment_variants_list.map((item, key) => (
              <div className={`ncart-payment-variant${payment_method === item.name ? ' active': ''}`}
                   key={key}
                   onClick={e => handleSelectMethod(e, item.name)}>

                  <img src={item.img} className="payment-img"></img>
                  <p className="cash-payment-title" >{item.title}</p>
                  <p className="cash-payment-description" >{item.description ? item.description : "\u00A0"}</p>
              </div>
          ))}
      </div>
  </div>
      {payment_method === "invoice" &&
      <>
      <div className={`nheader${not_loaded ? ' blur': '' }`}><h2>Реквизиты организации</h2></div>
          <div className="nbody invoce-payment">
              <div className='row'>
                  <div className='col-md-12'>
                      <div className="input-group">
                          <div className="form-line">
                              <input type="text"
                                     className="form-control"
                                     placeholder="Полное наименование организации"
                                     value={invoice.name}
                                     onChange={ e => handleChangInput("name", e.currentTarget.value)}
                                     onBlur={e => handleSetValue("name",e)}
                                     onKeyDown={e => e.key === 'Enter' && handleSetValue("name",e)}
                              />
                          </div>

                        {invoice_name_error && <span className="text-danger small form-error">{invoice_name_error}</span> }
                      </div>
                  </div>
              </div>
              <div className='row'>
                  <div className='col-md-4'>
                      <div className="input-group">
                          <div className="form-line">
                              <input type="text"
                                     className="form-control"
                                     placeholder="ИНН"
                                     value={invoice.inn}
                                     onChange={ e => handleChangInput("inn", e.currentTarget.value)}
                                     onBlur={e => handleSetValue("inn",e)}
                                     onKeyDown={e => e.key === 'Enter' && handleSetValue("inn",e)}
                              />
                          </div>

                        {invoice_inn_error && <span className="text-danger small form-error">{invoice_inn_error}</span> }
                      </div>
                  </div>

                  <div className='col-md-4'>
                      <div className="input-group">
                          <div className="form-line">
                              <input type="text"
                                     className="form-control"
                                     placeholder="ОГРН"
                                     value={payment_variants.invoice.data.ogrn}
                                     onChange={ e => handleChangInput("ogrn", e.currentTarget.value)}
                                     onBlur={e => handleSetValue("ogrn",e)}
                                     onKeyDown={e => e.key === 'Enter' && handleSetValue("ogrn",e)}
                              />
                          </div>

                        {invoice_ogrn_error && <span className="text-danger small form-error">{invoice_ogrn_error}</span> }
                      </div>
                  </div>

                  <div className='col-md-4'>
                      <div className="input-group">
                          <div className="form-line">
                              <input type="text"
                                     className="form-control"
                                     placeholder="КПП"
                                     value={invoice.kpp}
                                     onChange={ e => handleChangInput("kpp", e.currentTarget.value)}
                                     onBlur={e => handleSetValue("kpp",e)}
                                     onKeyDown={e => e.key === 'Enter' && handleSetValue("kpp",e)}
                              />
                          </div>

                        {invoice_kpp_error && <span className="text-danger small form-error">{invoice_kpp_error}</span> }
                      </div>
                  </div>

              </div>
              <div className='row'>
                  <div className='col-md-12'>
                      <div className="input-group">
                          <div className="form-line">
                              <input type="text"
                                     className="form-control"
                                     placeholder="Юридический адрес организации"
                                     value={invoice.address}
                                     onChange={ e => handleChangInput("address", e.currentTarget.value)}
                                     onBlur={e => handleSetValue("address",e)}
                                     onKeyDown={e => e.key === 'Enter' && handleSetValue("address",e)}
                              />
                          </div>

                        {invoice_address_error && <span className="text-danger small form-error">{invoice_address_error}</span> }
                      </div>
                  </div>
              </div>
              <div className='row'>
                  <div className='col-md-12'>
                      <div className="input-group">
                          <div className="form-line">
                              <input type="text"
                                     className="form-control"
                                     placeholder="Фактический адрес организации"
                                     value={invoice.real_address}
                                     readOnly={invoice.same_address}
                                     onChange={ e => handleChangInput("real_address", e.currentTarget.value)}
                                     onBlur={e => handleSetValue("real_address",e)}
                                     onKeyDown={e => e.key === 'Enter' && handleSetValue("real_address",e)}
                              />
                          </div>

                        {invoice_real_address_error && <span className="text-danger small form-error">{invoice_real_address_error}</span> }
                      </div>
                  </div>
              </div>
              <div className='row'>
                  <div className='col-md-6'>
                      <div className="input-group">
                          <div className="form-line">
                              <input type="text"
                                     className="form-control"
                                     placeholder="Телефон организации"
                                     value={invoice.phone}
                                     onChange={ e => handleChangInput("phone", e.currentTarget.value)}
                                     onBlur={e => handleSetValue("phone",e)}
                                     onKeyDown={e => e.key === 'Enter' && handleSetValue("phone",e)}
                              />
                          </div>

                        {invoice_phone_error && <span className="text-danger small form-error">{invoice_phone_error}</span> }
                      </div>
                  </div>
                  <div className='col-md-6'>
                      <div className="input-group">
                          <div className="invoce-same-adress">
                              <input type="checkbox" id="invoice_adress_checkbox"
                              className="ncart-checkbox filled-in"
                              checked={invoice.same_address}
                              onChange={e => handleChangeSame(e)}/>
                              <label htmlFor="invoice_adress_checkbox">Юридический и физический адрес совпадают</label>
                          </div>

                      </div>
                  </div>
              </div>
              <h4>Платежные данные</h4>
              <div className='row'>
                  <div className='col-md-6'>
                      <div className="input-group">
                          <div className="form-line">
                              <input type="text"
                                     className="form-control"
                                     placeholder="Банк"
                                     value={invoice.bank}
                                     onChange={ e => handleChangInput("bank", e.currentTarget.value)}
                                     onBlur={e => handleSetValue("bank",e)}
                                     onKeyDown={e => e.key === 'Enter' && handleSetValue("bank",e)}
                              />
                          </div>

                        {invoice_bank_error && <span className="text-danger small form-error">{invoice_bank_error}</span> }
                      </div>
                  </div>
                  <div className='col-md-6'>
                      <div className="input-group">
                          <div className="form-line">
                              <input type="text"
                                     className="form-control"
                                     placeholder="БИК"
                                     value={invoice.bik}
                                     onChange={ e => handleChangInput("bik", e.currentTarget.value)}
                                     //onBlur={e => handleSetValue("bik",e)}
                                     //onKeyDown={e => e.key === 'Enter' && handleSetValue("bik",e)}
                              />
                          </div>

                        {invoice_bik_error && <span className="text-danger small form-error">{invoice_bik_error}</span> }
                      </div>
                  </div>
              </div>
                            <div className='row'>
                  <div className='col-md-6'>
                      <div className="input-group">
                          <div className="form-line">
                              <input type="text"
                                     className="form-control"
                                     placeholder="Кор. счет"
                                     value={invoice.bank_schet}
                                     onChange={ e => handleChangInput("bank_schet", e.currentTarget.value)}
                                     onBlur={e => handleSetValue("bank_schet",e)}
                                     onKeyDown={e => e.key === 'Enter' && handleSetValue("bank_schet",e)}
                              />
                          </div>

                        {invoice_bank_schet_error && <span className="text-danger small form-error">{invoice_bank_schet_error}</span> }
                      </div>
                  </div>
                  <div className='col-md-6'>
                      <div className="input-group">
                          <div className="form-line">
                              <input type="text"
                                     className="form-control"
                                     placeholder="Расчетный счет"
                                     value={invoice.org_schet}
                                     onChange={ e => handleChangInput("org_schet", e.currentTarget.value)}
                                     onBlur={e => handleSetValue("org_schet",e)}
                                     onKeyDown={e => e.key === 'Enter' && handleSetValue("org_schet",e)}
                              />
                          </div>

                        {invoice_org_schet_error && <span className="text-danger small form-error">{invoice_org_schet_error}</span> }
                      </div>
                  </div>
              </div>
          </div>
      </>
      }
    </>
)}

const mapStateToProps = state => ({
    cart_status: state.ncart.status,
    cart_num_items: state.ncart.num_items,
    cart_items: state.ncart.items,
    cart_total: state.ncart.total,
    payment_method: state.npayment.method,
    payment_title: state.npayment.title,
    payment_variants: state.npayment.variants,
    invoice_variant: state.npayment.variants.invoice
})

const mapDispatchToProps = dispatch => bindActionCreators({ setPaymentMethod, setInvoiceData, setPaymentData}, dispatch);

export default connect(
  mapStateToProps,
    mapDispatchToProps
)(NPayment)
